import React from "react";

export const OpenEye = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <g clipPath="url(#clip0_2293_2212)">
      <path
        d="M23.9583 12.4997C23.9583 12.4997 19.7917 20.833 12.5 20.833C5.20833 20.833 1.04166 12.4997 1.04166 12.4997C1.04166 12.4997 5.20833 4.16634 12.5 4.16634C19.7917 4.16634 23.9583 12.4997 23.9583 12.4997Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 9.37467C10.7741 9.37467 9.375 10.7738 9.375 12.4997C9.375 14.2256 10.7741 15.6247 12.5 15.6247C14.2259 15.6247 15.625 14.2256 15.625 12.4997C15.625 10.7738 14.2259 9.37467 12.5 9.37467Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2293_2212">
        <rect
          width="25"
          height="25"
          fill="white"
          transform="matrix(-1 0 0 -1 25 25)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ClosedEye = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <g clipPath="url(#clip0_2293_2239)">
      <path
        d="M6.31251 6.31217C8.09315 4.95488 10.2614 4.20294 12.5 4.16634C19.7917 4.16634 23.9583 12.4997 23.9583 12.4997C22.6626 14.9144 20.8655 17.024 18.6875 18.6872M14.6875 20.583C13.9705 20.7508 13.2364 20.8347 12.5 20.833C5.20834 20.833 1.04168 12.4997 1.04168 12.4997C1.67399 11.3168 2.42808 10.2031 3.29168 9.17676M10.2917 10.2913C10.5778 9.98431 10.9228 9.73806 11.3061 9.56726C11.6894 9.39646 12.1032 9.30461 12.5228 9.29721C12.9424 9.28981 13.3592 9.36699 13.7483 9.52416C14.1375 9.68133 14.4909 9.91527 14.7877 10.212C15.0844 10.5088 15.3184 10.8622 15.4755 11.2514C15.6327 11.6405 15.7099 12.0573 15.7025 12.4769C15.6951 12.8964 15.6032 13.3103 15.4324 13.6936C15.2616 14.0769 15.0154 14.4219 14.7083 14.708M23.9583 23.958L1.04168 1.04134"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2293_2239">
        <rect
          width="25"
          height="25"
          fill="white"
          transform="matrix(-1 0 0 -1 25 25)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const EditProfileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <g clipPath="url(#clip0_2340_4587)">
      <path
        d="M14 17.5C17.866 17.5 21 14.366 21 10.5C21 6.63401 17.866 3.5 14 3.5C10.134 3.5 7 6.63401 7 10.5C7 14.366 10.134 17.5 14 17.5Z"
        stroke="#FFF5F5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 23.625C5.61859 19.9642 9.46641 17.5 14 17.5C18.5336 17.5 22.3814 19.9642 24.5 23.625"
        stroke="#FFF5F5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2340_4587">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LanguageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M14 27C21.1797 27 27 21.1797 27 14C27 6.8203 21.1797 1 14 1M14 27C6.8203 27 1 21.1797 1 14C1 6.8203 6.8203 1 14 1M14 27C16.6924 27 18.875 21.1797 18.875 14C18.875 6.8203 16.6924 1 14 1M14 27C11.3076 27 9.125 21.1797 9.125 14C9.125 6.8203 11.3076 1 14 1M1.8125 14H26.1875"
      stroke="#FFF5F5"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const NotificationsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M12 23C12 23.7956 12.3161 24.5587 12.8787 25.1213C13.4413 25.6839 14.2044 26 15 26C15.7956 26 16.5587 25.6839 17.1213 25.1213C17.6839 24.5587 18 23.7956 18 23"
      stroke="#FFF5F5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 4C22.2771 5.23215 23.3129 6.9585 24 9"
      stroke="#FFF5F5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 9C6.68711 6.9585 7.72292 5.23215 9 4"
      stroke="#FFF5F5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.63215 14.0526C7.63215 11.9169 8.4083 9.86872 9.78984 8.35856C11.1714 6.8484 13.0452 6 14.999 6C16.9528 6 18.8266 6.8484 20.2081 8.35856C21.5897 9.86872 22.3658 11.9169 22.3658 14.0526C22.3658 18.0588 23.215 20.3829 23.8903 21.6579C23.9621 21.7937 23.9999 21.9477 24 22.1045C24.0001 22.2613 23.9626 22.4153 23.8911 22.5513C23.8196 22.6872 23.7166 22.8002 23.5926 22.8789C23.4686 22.9577 23.3278 22.9994 23.1843 23H6.81361C6.67035 22.9991 6.52982 22.957 6.40607 22.8781C6.28232 22.7992 6.17969 22.6862 6.10843 22.5503C6.03717 22.4144 5.99978 22.2605 6 22.1039C6.00022 21.9473 6.03804 21.7935 6.10967 21.6579C6.78394 20.3829 7.63215 18.0577 7.63215 14.0526Z"
      stroke="#FFF5F5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClearHistoryIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M26.25 11.25C25.7853 11.25 25.5526 11.2497 25.3594 11.2881C24.5663 11.446 23.946 12.0663 23.7881 12.8594C23.7497 13.0526 23.75 13.2853 23.75 13.75V20.25C23.75 23.0784 23.7498 24.4924 22.8711 25.3711C21.9924 26.2498 20.5784 26.25 17.75 26.25H12.25C9.42157 26.25 8.00759 26.2498 7.12891 25.3711C6.25023 24.4924 6.25 23.0784 6.25 20.25V13.75C6.25 13.2853 6.25034 13.0526 6.21191 12.8594C6.05401 12.0663 5.43371 11.446 4.64062 11.2881C4.44743 11.2497 4.21466 11.25 3.75 11.25V7.5H26.25V11.25ZM11.875 12.75C11.3227 12.75 10.875 13.1977 10.875 13.75V20C10.875 20.5523 11.3227 21 11.875 21C12.4273 21 12.875 20.5523 12.875 20V13.75C12.875 13.1977 12.4273 12.75 11.875 12.75ZM18.125 12.75C17.5727 12.75 17.125 13.1977 17.125 13.75V20C17.125 20.5523 17.5727 21 18.125 21C18.6773 21 19.125 20.5523 19.125 20V13.75C19.125 13.1977 18.6773 12.75 18.125 12.75Z"
      fill="#FFF5F5"
    />
    <path
      d="M12.5852 4.21324C12.7276 4.08034 13.0415 3.96291 13.4781 3.87915C13.9147 3.7954 14.4497 3.75 15 3.75C15.5503 3.75 16.0853 3.7954 16.5219 3.87915C16.9585 3.96291 17.2724 4.08034 17.4148 4.21324"
      stroke="#FFF5F5"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const LogOutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="20"
    viewBox="0 0 23 20"
    fill="none"
  >
    <path
      d="M1.28027 9.91682L0.499405 9.29212L-0.00035131 9.91682L0.499405 10.5415L1.28027 9.91682ZM9.90527 10.9168C10.4576 10.9168 10.9053 10.4691 10.9053 9.91682C10.9053 9.36453 10.4576 8.91682 9.90527 8.91682V9.91682V10.9168ZM13.2477 1.69308L13.4121 2.67948V2.67948L13.2477 1.69308ZM14.4189 1.49788L14.5833 2.48428V2.48428L14.4189 1.49788ZM14.4189 18.3358L14.5833 17.3494L14.5833 17.3494L14.4189 18.3358ZM13.2477 18.1406L13.0833 19.1269L13.0833 19.1269L13.2477 18.1406ZM10.3792 17.182L11.1423 16.5356L11.1423 16.5356L10.3792 17.182ZM20.3444 18.2478L20.9908 19.0108H20.9908L20.3444 18.2478ZM20.3444 1.5858L19.698 2.34882V2.34882L20.3444 1.5858ZM10.3792 2.65165L9.61621 2.00528V2.00528L10.3792 2.65165ZM5.11361 5.12515L4.33274 4.50045L0.499405 9.29212L1.28027 9.91682L2.06114 10.5415L5.89448 5.74984L5.11361 5.12515ZM1.28027 9.91682L0.499405 10.5415L4.33274 15.3332L5.11361 14.7085L5.89448 14.0838L2.06114 9.29212L1.28027 9.91682ZM1.28027 9.91682V10.9168H9.90527V9.91682V8.91682H1.28027V9.91682ZM13.2477 1.69308L13.4121 2.67948L14.5833 2.48428L14.4189 1.49788L14.2545 0.511487L13.0833 0.706688L13.2477 1.69308ZM21.4053 7.41624H20.4053V12.4174H21.4053H22.4053V7.41624H21.4053ZM14.4189 18.3358L14.5833 17.3494L13.4121 17.1542L13.2477 18.1406L13.0833 19.1269L14.2545 19.3221L14.4189 18.3358ZM9.90527 6.20992H10.9053V5.63866H9.90527H8.90527V6.20992H9.90527ZM9.90527 14.195H10.9053V13.8134H9.90527H8.90527V14.195H9.90527ZM13.2477 18.1406L13.4121 17.1542C12.5886 17.0169 12.0626 16.9274 11.6779 16.8129C11.32 16.7063 11.2062 16.6111 11.1423 16.5356L10.3792 17.182L9.61621 17.8284C10.0262 18.3123 10.5485 18.5634 11.1072 18.7297C11.6392 18.8881 12.3104 18.9981 13.0833 19.1269L13.2477 18.1406ZM9.90527 14.195H8.90527C8.90527 14.9785 8.90346 15.6586 8.97222 16.2094C9.04445 16.7879 9.20623 17.3444 9.61621 17.8284L10.3792 17.182L11.1423 16.5356C11.0783 16.4601 11.0031 16.3322 10.9568 15.9617C10.9071 15.5634 10.9053 15.0298 10.9053 14.195H9.90527ZM21.4053 12.4174H20.4053C20.4053 14.0919 20.4029 15.2404 20.2826 16.088C20.1662 16.9079 19.9619 17.2612 19.698 17.4848L20.3444 18.2478L20.9908 19.0108C21.7877 18.3357 22.1139 17.4178 22.2627 16.3691C22.4077 15.348 22.4053 14.0307 22.4053 12.4174H21.4053ZM14.4189 18.3358L14.2545 19.3221C15.8459 19.5874 17.1449 19.8063 18.1758 19.8312C19.2347 19.8568 20.1938 19.686 20.9908 19.0108L20.3444 18.2478L19.698 17.4848C19.4341 17.7084 19.052 17.8518 18.2241 17.8318C17.3683 17.8111 16.235 17.6246 14.5833 17.3494L14.4189 18.3358ZM14.4189 1.49788L14.5833 2.48428C16.235 2.20899 17.3683 2.02252 18.2241 2.00185C19.052 1.98185 19.4341 2.12525 19.698 2.34882L20.3444 1.5858L20.9908 0.822784C20.1938 0.14766 19.2347 -0.0231532 18.1758 0.0024296C17.1449 0.0273373 15.8459 0.246253 14.2545 0.511487L14.4189 1.49788ZM21.4053 7.41624H22.4053C22.4053 5.80289 22.4077 4.48559 22.2627 3.46457C22.1139 2.41587 21.7877 1.49791 20.9908 0.822784L20.3444 1.5858L19.698 2.34882C19.9619 2.5724 20.1662 2.92574 20.2826 3.74563C20.4029 4.59319 20.4053 5.74177 20.4053 7.41624H21.4053ZM13.2477 1.69308L13.0833 0.706688C12.3104 0.835493 11.6392 0.945521 11.1072 1.1039C10.5485 1.27025 10.0262 1.52131 9.61621 2.00528L10.3792 2.65165L11.1423 3.29803C11.2062 3.2225 11.32 3.12731 11.6779 3.02076C12.0626 2.90624 12.5886 2.81672 13.4121 2.67948L13.2477 1.69308ZM9.90527 5.63866H10.9053C10.9053 4.80381 10.9071 4.27023 10.9568 3.87198C11.0031 3.50143 11.0783 3.37355 11.1423 3.29803L10.3792 2.65165L9.61621 2.00528C9.20623 2.48925 9.04445 3.0457 8.97222 3.6242C8.90346 4.17498 8.90527 4.85516 8.90527 5.63866H9.90527Z"
      fill="#FFF5F5"
    />
  </svg>
);

export const ArrowDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.99967 3.33301V12.6663M7.99967 12.6663L12.6663 7.99967M7.99967 12.6663L3.33301 7.99967"
      stroke="#667085"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SaveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 14L11.6464 14.3536L12 14.7071L12.3536 14.3536L12 14ZM12.5 5C12.5 4.72386 12.2761 4.5 12 4.5C11.7239 4.5 11.5 4.72386 11.5 5L12 5L12.5 5ZM7 9L6.64645 9.35355L11.6464 14.3536L12 14L12.3536 13.6464L7.35355 8.64645L7 9ZM12 14L12.3536 14.3536L17.3536 9.35355L17 9L16.6464 8.64645L11.6464 13.6464L12 14ZM12 14L12.5 14L12.5 5L12 5L11.5 5L11.5 14L12 14Z"
      fill="#222222"
    />
    <path
      d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16"
      stroke="#222222"
    />
  </svg>
);

export const EditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-pencil-icon lucide-pencil"
  >
    <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
    <path d="m15 5 4 4" />
  </svg>
);

export const ConnectionLostIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    style={{ flexShrink: 0 }}
  >
    <path
      d="M30 50H30.025"
      stroke="#6B4FBB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.25 41.0725C23.5866 38.7821 26.7281 37.4993 30 37.4993C33.2719 37.4993 36.4134 38.7821 38.75 41.0725"
      stroke="#6B4FBB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 32.1476C16.0451 28.6724 20.5445 26.3313 25.425 25.4226"
      stroke="#6B4FBB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.4999 32.1476C45.9946 30.672 44.3088 29.3926 42.4824 28.3401"
      stroke="#6B4FBB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 22.0499C8.09149 19.2851 11.6202 17.0523 15.4425 15.4424"
      stroke="#6B4FBB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M55.0003 22.05C51.1871 18.6396 46.7164 16.0454 41.8633 14.4271C37.0101 12.8088 31.8772 12.2007 26.7803 12.64"
      stroke="#6B4FBB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 5L55 55"
      stroke="#6B4FBB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UnexpectedErrorIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="76"
    height="76"
    viewBox="0 0 76 76"
    fill="none"
    style={{ flexShrink: 0 }}
  >
    <path
      d="M63.3337 41.1668C63.3337 57.0001 52.2503 64.9168 39.077 69.5085C38.3872 69.7422 37.6379 69.731 36.9553 69.4768C23.7503 64.9168 12.667 57.0001 12.667 41.1668V19.0001C12.667 18.1603 13.0006 17.3548 13.5945 16.761C14.1884 16.1671 14.9938 15.8335 15.8337 15.8335C22.167 15.8335 30.0837 12.0335 35.5937 7.22012C36.2645 6.64695 37.1179 6.33203 38.0003 6.33203C38.8827 6.33203 39.7361 6.64695 40.407 7.22012C45.9487 12.0651 53.8337 15.8335 60.167 15.8335C61.0068 15.8335 61.8123 16.1671 62.4062 16.761C63 17.3548 63.3337 18.1603 63.3337 19.0001V41.1668Z"
      stroke="#6B4FBB"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.9163 30.0833L30.083 45.9166"
      stroke="#6B4FBB"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.083 30.0833L45.9163 45.9166"
      stroke="#6B4FBB"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LoginFailedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="68"
    height="68"
    viewBox="0 0 68 68"
    fill="none"
    style={{ flexShrink: 0 }}
  >
    <path
      d="M34.0003 62.3333C49.6484 62.3333 62.3337 49.648 62.3337 34C62.3337 18.3519 49.6484 5.66663 34.0003 5.66663C18.3523 5.66663 5.66699 18.3519 5.66699 34C5.66699 49.648 18.3523 62.3333 34.0003 62.3333Z"
      stroke="#6B4FBB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.5 25.5L25.5 42.5"
      stroke="#6B4FBB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.5 25.5L42.5 42.5"
      stroke="#6B4FBB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InvalidFileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    style={{ flexShrink: 0 }}
  >
    <g clipPath="url(#clip0_381_421)">
      <path
        d="M50 56H14C13.4696 56 12.9609 55.7893 12.5858 55.4142C12.2107 55.0391 12 54.5304 12 54V10C12 9.46957 12.2107 8.96086 12.5858 8.58579C12.9609 8.21071 13.4696 8 14 8H38L52 22V54C52 54.5304 51.7893 55.0391 51.4142 55.4142C51.0391 55.7893 50.5304 56 50 56Z"
        stroke="#6B4FBB"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 8V22H52"
        stroke="#6B4FBB"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 32L38 44"
        stroke="#6B4FBB"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 32L26 44"
        stroke="#6B4FBB"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_381_421">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LargeFileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="68"
    height="68"
    viewBox="0 0 68 68"
    fill="none"
    style={{ flexShrink: 0 }}
  >
    <g clipPath="url(#clip0_370_365)">
      <path
        d="M40.375 8.5V23.375H55.25"
        stroke="#6B4FBB"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51 59.5H53.125C53.6886 59.5 54.2291 59.2761 54.6276 58.8776C55.0261 58.4791 55.25 57.9386 55.25 57.375V23.375L40.375 8.5H14.875C14.3114 8.5 13.7709 8.72388 13.3724 9.1224C12.9739 9.52091 12.75 10.0614 12.75 10.625V29.75"
        stroke="#6B4FBB"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.75 40.375H12.75C11.5764 40.375 10.625 41.3264 10.625 42.5V55.25C10.625 56.4236 11.5764 57.375 12.75 57.375H29.75C30.9236 57.375 31.875 56.4236 31.875 55.25V42.5C31.875 41.3264 30.9236 40.375 29.75 40.375Z"
        stroke="#6B4FBB"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.875 45.6875L40.375 40.375V57.375L31.875 52.0625"
        stroke="#6B4FBB"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_370_365">
        <rect width="68" height="68" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BadgeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
  >
    <path
      d="M5.16211 14.8674C6.7623 13.1435 9.72119 13.0624 11.3386 14.8674M9.96266 9.5733C9.96266 10.5479 9.19343 11.338 8.24453 11.338C7.29564 11.338 6.5264 10.5479 6.5264 9.5733C6.5264 8.59868 7.29564 7.80859 8.24453 7.80859C9.19343 7.80859 9.96266 8.59868 9.96266 9.5733Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M6.04412 2.51562C3.71083 2.52432 2.46265 2.60591 1.65452 3.3715C0.75 4.22842 0.75 5.60761 0.75 8.36598V12.5455C0.75 15.3039 0.75 16.6831 1.65452 17.54C2.55905 18.3969 4.01485 18.3969 6.92647 18.3969H9.57353C12.4851 18.3969 13.941 18.3969 14.8455 17.54C15.75 16.6831 15.75 15.3039 15.75 12.5455V8.36598C15.75 5.60761 15.75 4.22842 14.8455 3.3715C14.0373 2.60591 12.7892 2.52432 10.4559 2.51562"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.28506 2.18968C6.36972 1.82367 6.41205 1.64066 6.49335 1.49121C6.68273 1.14305 7.03209 0.887188 7.44914 0.791203C7.62817 0.75 7.83571 0.75 8.2508 0.75C8.6659 0.75 8.87344 0.75 9.05247 0.791203C9.46952 0.887188 9.81887 1.14305 10.0083 1.49121C10.0896 1.64066 10.1319 1.82367 10.2165 2.18968L10.29 2.50743C10.4402 3.15656 10.5153 3.48113 10.402 3.7308C10.3287 3.8925 10.2037 4.03096 10.0429 4.12863C9.79458 4.27941 9.42649 4.27941 8.69031 4.27941H7.8113C7.07512 4.27941 6.70703 4.27941 6.45876 4.12863C6.29795 4.03096 6.17296 3.8925 6.0996 3.7308C5.98634 3.48113 6.06141 3.15656 6.21156 2.50743L6.28506 2.18968Z"
      stroke="white"
      strokeWidth="1.5"
    />
  </svg>
);

export const DashboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <rect
      x="12.877"
      y="11.6875"
      width="7.125"
      height="8.3125"
      rx="1"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <rect
      x="12.877"
      y="1"
      width="7.125"
      height="5.9375"
      rx="1"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <rect
      x="1"
      y="14.0625"
      width="7.125"
      height="5.9375"
      rx="1"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <rect
      x="1"
      y="1"
      width="7.125"
      height="8.3125"
      rx="1"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="23"
    viewBox="0 0 26 23"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.0643 10.6338L7.06431 9.63379H7.0643V10.6338ZM10.8153 12.3232L10.9795 13.3097L12.7948 13.0075L11.5536 11.6488L10.8153 12.3232ZM4.45004 18.4121V19.4121H5.20178L5.41066 18.69L4.45004 18.4121ZM1.02133 17.3252L0.0421892 17.122L0.0421653 17.1221L1.02133 17.3252ZM7.0643 10.6338L7.06428 11.6338C8.37347 11.6338 9.33251 12.1828 10.077 12.9977L10.8153 12.3232L11.5536 11.6488C10.4998 10.4953 9.03083 9.63381 7.06431 9.63379L7.0643 10.6338ZM10.8153 12.3232L10.651 11.3368C6.09696 12.095 4.2328 15.5642 3.48942 18.1343L4.45004 18.4121L5.41066 18.69C6.05614 16.4583 7.52437 13.8849 10.9795 13.3097L10.8153 12.3232ZM4.45004 18.4121V17.4121H1.94711V18.4121V19.4121H4.45004V18.4121ZM1.94711 18.4121V17.4121C1.94172 17.4121 1.95612 17.4114 1.97345 17.4314C1.98215 17.4415 1.99167 17.4571 1.99735 17.478C2.00343 17.5005 2.00236 17.5193 2.00049 17.5283L1.02133 17.3252L0.0421653 17.1221C-0.219535 18.3839 0.786298 19.4121 1.94711 19.4121V18.4121ZM1.02133 17.3252L2.00047 17.5284C2.21212 16.5085 2.64903 14.9806 3.48003 13.731C4.29383 12.5072 5.41832 11.6338 7.0643 11.6338V10.6338V9.63379C4.54502 9.63379 2.87001 11.0364 1.81463 12.6235C0.776453 14.1847 0.274503 16.0025 0.0421892 17.122L1.02133 17.3252Z"
      fill="#64309E"
    />
    <path
      d="M17.957 10.6338L17.957 9.63379H17.957V10.6338ZM24 17.3252L24.9792 17.1222L24.9791 17.122L24 17.3252ZM20.5703 18.4121L19.6097 18.69L19.8186 19.4121H20.5703V18.4121ZM14.2051 12.3232L13.4667 11.6488L12.2258 13.0074L14.0408 13.3097L14.2051 12.3232ZM17.957 10.6338L17.957 11.6338C19.603 11.6338 20.7275 12.5072 21.5413 13.731C22.3723 14.9806 22.8092 16.5085 23.0209 17.5284L24 17.3252L24.9791 17.122C24.7468 16.0025 24.2449 14.1847 23.2067 12.6235C22.1513 11.0365 20.4763 9.63382 17.957 9.63379L17.957 10.6338ZM24 17.3252L23.0208 17.5282C23.019 17.5192 23.0179 17.5005 23.024 17.478C23.0296 17.4571 23.0392 17.4415 23.0479 17.4314C23.0652 17.4114 23.0796 17.4121 23.0742 17.4121V18.4121V19.4121C24.2351 19.4121 25.2408 18.3839 24.9792 17.1222L24 17.3252ZM23.0742 18.4121V17.4121H20.5703V18.4121V19.4121H23.0742V18.4121ZM20.5703 18.4121L21.5309 18.1343C20.7876 15.5642 18.9233 12.0951 14.3693 11.3368L14.2051 12.3232L14.0408 13.3097C17.4959 13.885 18.9642 16.4584 19.6097 18.69L20.5703 18.4121ZM14.2051 12.3232L14.9434 12.9976C15.6877 12.1827 16.6473 11.6338 17.957 11.6338V10.6338V9.63379C15.9905 9.63379 14.5207 10.4949 13.4667 11.6488L14.2051 12.3232Z"
      fill="#64309E"
    />
    <path
      d="M12.5092 12.1885C19.3329 12.1885 20.7145 18.1251 20.9942 20.5291C21.0581 21.0777 20.6175 21.522 20.0652 21.522H4.95313C4.40084 21.522 3.9603 21.0777 4.02414 20.5291C4.30386 18.1251 5.68545 12.1885 12.5092 12.1885Z"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M9.47852 1.99886C9.00155 1.52192 8.39387 1.19712 7.73231 1.06553C7.07074 0.933942 6.38501 1.00148 5.76183 1.2596C5.13865 1.51772 4.60601 1.95483 4.23127 2.51565C3.85652 3.07648 3.6565 3.73583 3.6565 4.41033C3.6565 5.08483 3.85652 5.74418 4.23126 6.305C4.60601 6.86583 5.13865 7.30294 5.76183 7.56106C6.38501 7.81918 7.07074 7.88671 7.7323 7.75513C8.39387 7.62354 8.68369 7.57963 9.16065 7.10269"
      stroke="#64309E"
      strokeWidth="2"
    />
    <path
      d="M15.5449 1.99886C16.0219 1.52192 16.6296 1.19712 17.2911 1.06553C17.9527 0.933942 18.6384 1.00148 19.2616 1.2596C19.8848 1.51772 20.4174 1.95483 20.7922 2.51565C21.1669 3.07648 21.3669 3.73583 21.3669 4.41033C21.3669 5.08483 21.1669 5.74418 20.7922 6.305C20.4174 6.86583 19.8848 7.30294 19.2616 7.56106C18.6384 7.81918 17.9527 7.88671 17.2911 7.75513C16.6296 7.62354 16.3397 7.57963 15.8628 7.10269"
      stroke="#64309E"
      strokeWidth="2"
    />
    <path
      d="M12.5107 1.52148C14.536 1.52151 16.1777 3.16343 16.1777 5.18848C16.1776 7.21342 14.5359 8.85544 12.5107 8.85547C10.4856 8.85547 8.84387 7.21343 8.84375 5.18848C8.84375 3.16342 10.4855 1.52148 12.5107 1.52148Z"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ContentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="24"
    viewBox="0 0 27 24"
    fill="none"
  >
    <ellipse
      cx="21.3124"
      cy="18.1877"
      rx="4.6877"
      ry="4.68762"
      transform="rotate(90 21.3124 18.1877)"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <ellipse
      cx="5.68933"
      cy="5.6877"
      rx="4.6877"
      ry="4.68762"
      transform="rotate(90 5.68933 5.6877)"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M1 18.1875L16.6254 18.1875"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M11.9375 5.6875L26.0004 5.6875"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const SystemIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="25"
    viewBox="0 0 27 25"
    fill="none"
  >
    <circle
      cx="13.2109"
      cy="12.501"
      r="3.75"
      stroke="#64309E"
      strokeWidth="2"
    />
    <path
      d="M1.79262 14.4445C1.26391 13.4941 0.999558 13.0188 0.999558 12.5C0.999558 11.9812 1.26391 11.5059 1.79262 10.5555L3.74961 7.0375L5.81779 3.5837C6.37654 2.65061 6.65592 2.18406 7.10525 1.92464C7.55458 1.66522 8.09831 1.65654 9.18577 1.6392L13.2109 1.575L17.2361 1.6392C18.3236 1.65654 18.8673 1.66522 19.3166 1.92464C19.766 2.18406 20.0453 2.65061 20.6041 3.5837L22.6723 7.0375L24.6292 10.5555C25.158 11.5059 25.4223 11.9812 25.4223 12.5C25.4223 13.0188 25.158 13.4941 24.6292 14.4445L22.6723 17.9625L20.6041 21.4163C20.0453 22.3494 19.766 22.8159 19.3166 23.0754C18.8673 23.3348 18.3236 23.3435 17.2361 23.3608L13.2109 23.425L9.18577 23.3608C8.09831 23.3435 7.55458 23.3348 7.10525 23.0754C6.65592 22.8159 6.37654 22.3494 5.81779 21.4163L3.74961 17.9625L1.79262 14.4445Z"
      stroke="#64309E"
      strokeWidth="2"
    />
  </svg>
);

export const AdminEditProfileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M12.5 15.625C15.9518 15.625 18.75 12.8268 18.75 9.375C18.75 5.92322 15.9518 3.125 12.5 3.125C9.04822 3.125 6.25 5.92322 6.25 9.375C6.25 12.8268 9.04822 15.625 12.5 15.625Z"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.125 21.0938C5.0166 17.8252 8.45215 15.625 12.5 15.625C16.5479 15.625 19.9834 17.8252 21.875 21.0938"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FlaggedResultsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M5.20825 22.9167V3.125"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.20825 4.16667H18.2291C19.0473 4.16667 19.4564 4.16667 19.6395 4.42848C19.8226 4.69029 19.6857 5.06908 19.4118 5.82666L17.9694 9.79541C17.8813 10.0385 17.8373 10.16 17.8373 10.2917C17.8373 10.4234 17.8813 10.5449 17.9694 10.7879L19.4118 14.7567C19.6857 15.5143 19.8226 15.8931 19.6395 16.1549C19.4564 16.4167 19.0473 16.4167 18.2291 16.4167H7.29159C6.13782 16.4167 5.56093 16.4167 5.20825 16.069V4.16667Z"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AuditLogsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="27"
    viewBox="0 0 25 27"
    fill="none"
  >
    <path
      d="M23.4138 13.5V22C23.4138 23.8856 23.4138 24.8284 22.828 25.4142C22.2422 26 21.2994 26 19.4138 26H4.47222C4.03362 26 3.81432 26 3.63006 25.9771C2.26649 25.8077 1.19234 24.7335 1.0229 23.3699C1 23.1857 1 22.9664 1 22.5278M1 22.5278V5C1 3.11438 1 2.17157 1.58579 1.58579C2.17157 1 3.11438 1 4.99999 1H19.4138C21.2994 1 22.2422 1 22.828 1.58579C23.4138 2.17157 23.4138 3.11438 23.4138 5V15.0556C23.4138 16.9412 23.4138 17.884 22.828 18.4698C22.2422 19.0556 21.2994 19.0556 19.4138 19.0556H4.47222C4.03362 19.0556 3.81432 19.0556 3.63006 19.0785C2.26649 19.2479 1.19234 20.322 1.0229 21.6856C1 21.8699 1 22.0892 1 22.5278Z"
      stroke="#64309E"
      strokeWidth="2"
    />
    <path
      d="M7.89648 7.89648L16.5172 7.89649"
      stroke="#64309E"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const LogoutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="21"
    viewBox="0 0 25 21"
    fill="none"
  >
    <path
      d="M1.28027 10.3809L0.499405 9.75623L-0.000351429 10.3809L0.499405 11.0056L1.28027 10.3809ZM10.2803 11.3809C10.8326 11.3809 11.2803 10.9332 11.2803 10.3809C11.2803 9.82864 10.8326 9.38093 10.2803 9.38093V10.3809V11.3809ZM13.672 1.85912L13.52 0.870745H13.52L13.672 1.85912ZM16.3679 1.44436L16.52 2.43274H16.52L16.3679 1.44436ZM16.3679 19.3175L16.2159 20.3059H16.2159L16.3679 19.3175ZM13.672 18.9027L13.8241 17.9144H13.8241L13.672 18.9027ZM22.2337 19.161L21.5825 18.402V18.402L22.2337 19.161ZM22.2337 1.60086L22.8848 0.841899V0.841899L22.2337 1.60086ZM10.7623 2.7945L10.0034 2.14337V2.14337L10.7623 2.7945ZM5.28027 5.38093L4.4994 4.75623L0.499405 9.75623L1.28027 10.3809L2.06114 11.0056L6.06114 6.00562L5.28027 5.38093ZM1.28027 10.3809L0.499405 11.0056L4.4994 16.0056L5.28027 15.3809L6.06114 14.7562L2.06114 9.75623L1.28027 10.3809ZM1.28027 10.3809V11.3809H10.2803V10.3809V9.38093H1.28027V10.3809ZM13.672 1.85912L13.8241 2.84749L16.52 2.43274L16.3679 1.44436L16.2159 0.455993L13.52 0.870745L13.672 1.85912ZM23.2803 7.3746H22.2803V13.3873H23.2803H24.2803V7.3746H23.2803ZM16.3679 19.3175L16.52 18.3291L13.8241 17.9144L13.672 18.9027L13.52 19.8911L16.2159 20.3059L16.3679 19.3175ZM10.2803 6.51286H11.2803V5.8126H10.2803H9.28027V6.51286H10.2803ZM10.2803 14.9493H11.2803V14.4469H10.2803H9.28027V14.9493H10.2803ZM13.672 18.9027L13.8241 17.9144C12.9893 17.7859 12.4556 17.702 12.0651 17.5907C11.7017 17.4871 11.5862 17.3919 11.5213 17.3162L10.7623 17.9674L10.0034 18.6185C10.4205 19.1047 10.9507 19.3527 11.517 19.5141C12.0562 19.6678 12.7364 19.7706 13.52 19.8911L13.672 18.9027ZM10.2803 14.9493H9.28027C9.28027 15.7421 9.27843 16.4299 9.34833 16.9863C9.42173 17.5705 9.58622 18.1322 10.0034 18.6185L10.7623 17.9674L11.5213 17.3162C11.4564 17.2406 11.3798 17.112 11.3327 16.737C11.2821 16.3341 11.2803 15.7939 11.2803 14.9493H10.2803ZM23.2803 13.3873H22.2803C22.2803 15.0429 22.2779 16.1779 22.1593 17.0163C22.0446 17.8269 21.8433 18.1783 21.5825 18.402L22.2337 19.161L22.8848 19.92C23.6706 19.2458 23.9926 18.3356 24.1396 17.2964C24.2826 16.2851 24.2803 14.9821 24.2803 13.3873H23.2803ZM16.3679 19.3175L16.2159 20.3059C17.7922 20.5484 19.0797 20.7488 20.101 20.7612C21.1504 20.774 22.099 20.5941 22.8848 19.92L22.2337 19.161L21.5825 18.402C21.3218 18.6258 20.9438 18.7713 20.1252 18.7614C19.2785 18.7511 18.1564 18.5809 16.52 18.3291L16.3679 19.3175ZM16.3679 1.44436L16.52 2.43274C18.1564 2.18098 19.2785 2.01075 20.1252 2.00048C20.9438 1.99055 21.3218 2.1361 21.5825 2.35983L22.2337 1.60086L22.8848 0.841899C22.099 0.167723 21.1504 -0.0121064 20.101 0.000622928C19.0797 0.0130109 17.7922 0.21348 16.2159 0.455993L16.3679 1.44436ZM23.2803 7.3746H24.2803C24.2803 5.77972 24.2826 4.47673 24.1396 3.46543C23.9926 2.42626 23.6706 1.51608 22.8848 0.841899L22.2337 1.60086L21.5825 2.35983C21.8433 2.58356 22.0446 2.93496 22.1593 3.74555C22.2779 4.58399 22.2803 5.71892 22.2803 7.3746H23.2803ZM13.672 1.85912L13.52 0.870745C12.7364 0.991303 12.0562 1.09407 11.517 1.24776C10.9507 1.40914 10.4205 1.65713 10.0034 2.14337L10.7623 2.7945L11.5213 3.44563C11.5862 3.36997 11.7017 3.27477 12.0651 3.17117C12.4556 3.05989 12.9893 2.97592 13.8241 2.84749L13.672 1.85912ZM10.2803 5.8126H11.2803C11.2803 4.96799 11.2821 4.42774 11.3327 4.02488C11.3798 3.64986 11.4564 3.5213 11.5213 3.44563L10.7623 2.7945L10.0034 2.14337C9.58622 2.62961 9.42173 3.19137 9.34833 3.77556C9.27843 4.33191 9.28027 5.01975 9.28027 5.8126H10.2803Z"
      fill="#64309E"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.16699 10H15.8337"
      stroke="#000"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.16699V15.8337"
      stroke="#000"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AuthenticIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M19.6797 0C30.5485 0 39.3592 8.81087 39.3594 19.6797C39.3594 30.5487 30.5487 39.3604 19.6797 39.3604C8.81072 39.3604 0 30.5487 0 19.6797C0.000169053 8.81087 8.81083 1.64943e-07 19.6797 0ZM29.3867 11.9678C28.7504 11.4377 27.8047 11.524 27.2744 12.1602L17.7432 23.5977C17.6054 23.7629 17.4917 23.8967 17.3926 24.0117C17.2834 23.9061 17.1581 23.7831 17.0059 23.6309L11.9941 18.6191C11.4085 18.0337 10.4588 18.0339 9.87305 18.6191C9.28726 19.2049 9.28726 20.1554 9.87305 20.7412L14.8838 25.752C15.2145 26.0826 15.5716 26.4442 15.9102 26.7002C16.2366 26.947 16.693 27.2122 17.2803 27.2529L17.5391 27.2559L17.7979 27.2295C18.3789 27.1356 18.8096 26.83 19.1123 26.5547C19.4262 26.2691 19.7486 25.8767 20.0479 25.5176L29.5791 14.0801C30.1091 13.4437 30.023 12.498 29.3867 11.9678Z"
      fill="#682B97"
    />
  </svg>
);

export const SuspiciousIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
  >
    <path
      d="M23.2279 3C23.9977 1.66667 25.9222 1.66667 26.692 3L44.8439 34.44C45.6137 35.7733 44.6515 37.44 43.1119 37.44H6.80811C5.26851 37.44 4.30626 35.7733 5.07606 34.44L23.2279 3Z"
      fill="#B161FF"
    />
    <line
      x1="24.374"
      y1="26.2822"
      x2="24.374"
      y2="13.3021"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="24.374"
      y1="32.0234"
      x2="24.374"
      y2="32.1396"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

export const AIGeneratedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M19.6807 0C30.5494 0.000189829 39.3602 8.81098 39.3604 19.6797C39.3604 30.5485 30.5495 39.3602 19.6807 39.3604C8.8117 39.3604 0 30.5487 0 19.6797C0.000169048 8.81087 8.8118 0 19.6807 0ZM29.1338 10.2266C28.7433 9.83604 28.1103 9.83604 27.7197 10.2266L19.6797 18.2656L11.6406 10.2266C11.2501 9.83618 10.617 9.83609 10.2266 10.2266C9.83624 10.6171 9.83623 11.2501 10.2266 11.6406L18.2656 19.6797L10.2266 27.7197C9.83604 28.1103 9.83604 28.7433 10.2266 29.1338C10.6171 29.5243 11.2501 29.5243 11.6406 29.1338L19.6797 21.0938L27.7197 29.1338C28.1103 29.5243 28.7442 29.5243 29.1348 29.1338C29.5249 28.7433 29.525 28.1102 29.1348 27.7197L21.0938 19.6797L29.1338 11.6406C29.5243 11.2501 29.5243 10.6171 29.1338 10.2266Z"
      fill="#7B1896"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
      stroke="#99A1AF"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0005 14.0005L11.1338 11.1338"
      stroke="#99A1AF"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clipPath="url(#clip0_2703_1600)">
      <path
        d="M5.83345 11.6667C5.8334 11.7751 5.86355 11.8813 5.92053 11.9736C5.97751 12.0658 6.05906 12.1403 6.15603 12.1887L7.3227 12.7721C7.41165 12.8165 7.5105 12.8375 7.60984 12.833C7.70918 12.8285 7.80573 12.7987 7.8903 12.7464C7.97487 12.6941 8.04467 12.621 8.09306 12.5341C8.14145 12.4472 8.16683 12.3494 8.16678 12.25V8.16667C8.16691 7.87756 8.27439 7.59879 8.46837 7.38442L12.6818 2.72417C12.7573 2.64049 12.807 2.53673 12.8248 2.42543C12.8426 2.31413 12.8277 2.20006 12.7821 2.09701C12.7364 1.99396 12.6619 1.90635 12.5675 1.84476C12.4731 1.78318 12.3628 1.75027 12.2501 1.75H1.75012C1.6373 1.75004 1.52692 1.78279 1.43234 1.84429C1.33777 1.90578 1.26305 1.99338 1.21724 2.09648C1.17144 2.19957 1.15651 2.31374 1.17426 2.42514C1.19202 2.53655 1.2417 2.64042 1.31728 2.72417L5.53186 7.38442C5.72584 7.59879 5.83332 7.87756 5.83345 8.16667V11.6667Z"
        stroke="#99A1AF"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2703_1600">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UserEditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_2654_2283)">
      <path
        d="M14.1156 4.54126C14.4681 4.18888 14.6662 3.71091 14.6662 3.2125C14.6663 2.71409 14.4683 2.23607 14.116 1.8836C13.7636 1.53112 13.2856 1.33307 12.7872 1.33301C12.2888 1.33295 11.8108 1.53088 11.4583 1.88326L2.56096 10.7826C2.40618 10.9369 2.29171 11.127 2.22763 11.3359L1.34696 14.2373C1.32973 14.2949 1.32843 14.3562 1.3432 14.4145C1.35796 14.4728 1.38824 14.5261 1.43083 14.5686C1.47341 14.6111 1.52671 14.6413 1.58507 14.656C1.64343 14.6707 1.70467 14.6693 1.7623 14.6519L4.6643 13.7719C4.87308 13.7084 5.06308 13.5947 5.21763 13.4406L14.1156 4.54126Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2654_2283">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UserPasswordIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.6667 7.33301H3.33333C2.59695 7.33301 2 7.92996 2 8.66634V13.333C2 14.0694 2.59695 14.6663 3.33333 14.6663H12.6667C13.403 14.6663 14 14.0694 14 13.333V8.66634C14 7.92996 13.403 7.33301 12.6667 7.33301Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66699 7.33301V4.66634C4.66699 3.78229 5.01818 2.93444 5.6433 2.30932C6.26842 1.6842 7.11627 1.33301 8.00033 1.33301C8.88438 1.33301 9.73223 1.6842 10.3573 2.30932C10.9825 2.93444 11.3337 3.78229 11.3337 4.66634V7.33301"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserDeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2 4H14"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6663 4V13.3333C12.6663 14 11.9997 14.6667 11.333 14.6667H4.66634C3.99967 14.6667 3.33301 14 3.33301 13.3333V4"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33301 3.99967V2.66634C5.33301 1.99967 5.99967 1.33301 6.66634 1.33301H9.33301C9.99967 1.33301 10.6663 1.99967 10.6663 2.66634V3.99967"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66699 7.33301V11.333"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33301 7.33301V11.333"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DateIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clipPath="url(#clip0_2717_3963)">
      <path
        d="M4.66699 1.16699V3.50033"
        stroke="#99A1AF"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33301 1.16699V3.50033"
        stroke="#99A1AF"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0833 2.33301H2.91667C2.27233 2.33301 1.75 2.85534 1.75 3.49967V11.6663C1.75 12.3107 2.27233 12.833 2.91667 12.833H11.0833C11.7277 12.833 12.25 12.3107 12.25 11.6663V3.49967C12.25 2.85534 11.7277 2.33301 11.0833 2.33301Z"
        stroke="#99A1AF"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 5.83301H12.25"
        stroke="#99A1AF"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2717_3963">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TopDividerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="1"
    viewBox="0 0 1916 1"
    preserveAspectRatio="none"
    fill="none"
  >
    <path d="M0 0.5L1916 0.499832" stroke="white" strokeOpacity="0.33" />
  </svg>
);

export const BottomDividerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1920"
    height="38"
    viewBox="0 0 1920 38"
    fill="none"
  >
    <g filter="url(#filter0_d_2942_4658)">
      <path
        d="M0 11H1920"
        stroke="white"
        strokeOpacity="0.33"
        strokeWidth="2"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2942_4658"
        x="-18"
        y="0"
        width="1956"
        height="38"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="9" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.331731 0 0 0 0 0.323249 0 0 0 0 0.310998 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2942_4658"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2942_4658"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const VerticalDividerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1"
    height="180"
    viewBox="0 0 1 180"
    fill="none"
  >
    <rect width="1" height="180" fill="url(#paint0_linear_2951_5286)" />
    <rect y="72" width="1" height="16" fill="white" fillOpacity="0.24" />
    <defs>
      <linearGradient
        id="paint0_linear_2951_5286"
        x1="0.499996"
        y1="0"
        x2="0.499996"
        y2="180"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F3EEFF" stopOpacity="0" />
        <stop offset="1" stopColor="#F3EEFF" stopOpacity="0.12" />
      </linearGradient>
    </defs>
  </svg>
);
